import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
const DEFAULT_PRODUCT_FILTER_STATE = {
  isFiltered: false,
  currentProductId: null,
  productName: ''
};

/**
 * Custom hook for managing product filter state
 * @param {Object} selectedProduct - Currently selected product
 * @returns {Object} Product filter state
 */
const useProductFilterState = selectedProduct => {
  const $ = _c(4);
  let t0;
  if ($[0] !== selectedProduct) {
    t0 = selectedProduct ? {
      isFiltered: true,
      currentProductId: selectedProduct.id,
      productName: selectedProduct.name
    } : DEFAULT_PRODUCT_FILTER_STATE;
    $[0] = selectedProduct;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isProductIdFiltered = t0;
  let t1;
  if ($[2] !== isProductIdFiltered) {
    t1 = {
      isProductIdFiltered
    };
    $[2] = isProductIdFiltered;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
export default useProductFilterState;